<ul class="nav nav-tabs">
    <li class="nav-item" *ngFor="let panel of panels" [ngClass]="panel.panelCustomClass">
        <a class="nav-link" [ngClass]="{active:panel.selected, disabled : panel.disabled}" [href]="''"
            (click)="select(panel)" onclick="return false;">{{panel.panelTitle}}</a>
    </li>
</ul>
<div class="bs5-tab-content">
    <ng-content></ng-content>
</div>